export default __webpack_public_path__ + "static/media/Frosthunter Arrows.c8755fcc.jpg";